import Charts from "@components/charts";
import { formatTooltip } from "../misc/constants";

const UpsellOver = ({ id, title, categories, series, height = 400, loading }) => {
    const chartOptions = {
        xAxis      : { categories },
        yAxis      : [{ title: { text: "Count" }, min: 0 }],
        plotOptions: {
            area: {
                fillOpacity: 0.3,
                marker     : {
                    enabled  : true,
                    radius   : 4,
                    lineWidth: 2,
                    lineColor: "#FFFFFF"
                }
            }
        },
        tooltip: {
            crosshairs: true,
            formatter () {
                return formatTooltip({
                    date : this.point.date,
                    count: this.point.count,
                    value: this.point.value,
                    label: "Upsell"
                });
            }
        }
    };

    return (
        <Charts
            id={id}
            type="area"
            height={height}
            loading={loading}
            categories={categories}
            series={series}
            cardHeader={{ title, desc: "" }}
            {...chartOptions}/>
    );
};

export default UpsellOver;
